// Components
import { Container, Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import MainButton from '@components/v25/ft1/buttons/MainButton'
import ExperienceCard from '@components/v25/ft1/cards/customer-experience/ExperienceCard'

interface ExperiencesData {
  img: string
  card?: {
    destination: string
    date: string
    prices: {
      old: number
      new: number
    }
  }
  review: {
    name: string
    quote: string
    message: string
    memberSince: number
  }
}

interface CustomerExperiencesProps {
  title: string
  description?: string
  redirectURL?: string
  onClick?: () => void
  experiences: ExperiencesData[]
}

const CustomerExperiences = ({
  title,
  description,
  redirectURL,
  onClick,
  experiences
}: CustomerExperiencesProps) => {
  return (
    <Section padding={[32, 0]}>
      <Container>
        <Flex flexDirection="column" rowGap={{ sm: 8 }} spacing={{ sm: 32 }}>
          <Text
            tagName="h2"
            variant="title-2"
            align="center"
            transform="capitalize"
          >
            {title}
          </Text>

          {description && (
            <Text variant="body-1" align="center">
              {description}
            </Text>
          )}
        </Flex>
        <Flex center flexDirection="column" rowGap={{ sm: 32 }}>
          {experiences.map((deal, index) => (
            <ExperienceCard {...deal} key={index} />
          ))}

          <MainButton redirectURL={redirectURL} onClick={onClick} />

          <div id="reviews-anchor"></div>
        </Flex>
      </Container>
    </Section>
  )
}

export default CustomerExperiences
